export default {
  root: ({ props }) => ({
    class: [
      // Flexbox and Position
      'inline-flex',
      'relative',

      // Shape
      'rounded-full',
      { 'shadow-lg': props.raised }
    ]
  }),
  button: {
    root: ({ parent, context }) => ({
      class: [
        'relative',

        // Alignments
        'items-center inline-flex text-center align-bottom justify-center',

        // Sizes & Spacing
        {
          'px-4 py-3 leading-none': parent.props.size === null && parent.props.label !== null,
          'text-sm py-2 px-3': parent.props.size === 'small',
          'text-xl py-3 px-4': parent.props.size === 'large'
        },
        {
          'h-12 w-12 p-0': parent.props.label == null
        },

        // Shape
        'rounded-r-none',
        'border-r-0',
        { 'rounded-l-full': parent.props.rounded },
        { 'rounded-md': !parent.props.rounded, 'rounded-full': parent.props.rounded },

        // Link Button
        { 'text-primary-600 bg-transparent border-transparent': parent.props.link },

        // Plain Button
        {
          'text-white bg-gray-500 border border-gray-500':
            parent.props.plain && !parent.props.outlined && !parent.props.text
        },
        // Plain Text Button
        { 'text-secondary-500': parent.props.plain && parent.props.text },
        // Plain Outlined Button
        { 'text-secondary-500 border border-gray-500': parent.props.plain && parent.props.outlined },

        // Text Button
        { 'bg-transparent border-transparent': parent.props.text && !parent.props.plain },

        // Outlined Button
        { 'bg-transparent border': parent.props.outlined && !parent.props.plain },

        // --- Severity Buttons ---

        // Primary Button
        {
          'text-white dark:text-secondary-900':
            !parent.props.link &&
            parent.props.severity === null &&
            !parent.props.text &&
            !parent.props.outlined &&
            !parent.props.plain,
          'bg-primary-500 dark:bg-primary-400':
            !parent.props.link &&
            parent.props.severity === null &&
            !parent.props.text &&
            !parent.props.outlined &&
            !parent.props.plain,
          'border border-primary-500 dark:border-primary-400':
            !parent.props.link &&
            parent.props.severity === null &&
            !parent.props.text &&
            !parent.props.outlined &&
            !parent.props.plain
        },
        // Primary Text Button
        {
          'text-primary-500 dark:text-primary-400':
            parent.props.text && parent.props.severity === null && !parent.props.plain
        },
        // Primary Outlined Button
        {
          'text-primary-500 border border-primary-500 hover:bg-primary-300/20':
            parent.props.outlined && parent.props.severity === null && !parent.props.plain
        },

        // Secondary Button
        {
          'text-white dark:text-secondary-900':
            parent.props.severity === 'secondary' &&
            !parent.props.text &&
            !parent.props.outlined &&
            !parent.props.plain,
          'bg-secondary-500 dark:bg-secondary-400':
            parent.props.severity === 'secondary' &&
            !parent.props.text &&
            !parent.props.outlined &&
            !parent.props.plain,
          'border border-secondary-500 dark:border-secondary-400':
            parent.props.severity === 'secondary' && !parent.props.text && !parent.props.outlined && !parent.props.plain
        },
        // Secondary Text Button
        {
          'text-secondary-500 dark:text-secondary-400':
            parent.props.text && parent.props.severity === 'secondary' && !parent.props.plain
        },
        // Secondary Outlined Button
        {
          'text-secondary-500 border border-secondary-500 hover:bg-secondary-300/20':
            parent.props.outlined && parent.props.severity === 'secondary' && !parent.props.plain
        },

        // Success Button
        {
          'text-white dark:text-secondary-900':
            parent.props.severity === 'success' && !parent.props.text && !parent.props.outlined && !parent.props.plain,
          'bg-green-500 dark:bg-green-400':
            parent.props.severity === 'success' && !parent.props.text && !parent.props.outlined && !parent.props.plain,
          'border border-green-500 dark:border-green-400':
            parent.props.severity === 'success' && !parent.props.text && !parent.props.outlined && !parent.props.plain
        },
        // Success Text Button
        {
          'text-secondary-500 dark:text-secondary-400':
            parent.props.text && parent.props.severity === 'secondary' && !parent.props.plain
        },
        // Success Outlined Button
        {
          'text-green-500 border border-green-500 hover:bg-green-300/20':
            parent.props.outlined && parent.props.severity === 'success' && !parent.props.plain
        },

        // Info Button
        {
          'text-white dark:text-secondary-900':
            parent.props.severity === 'info' && !parent.props.text && !parent.props.outlined && !parent.props.plain,
          'bg-info-500 dark:bg-info-400':
            parent.props.severity === 'info' && !parent.props.text && !parent.props.outlined && !parent.props.plain,
          'border border-info-500 dark:border-info-400':
            parent.props.severity === 'info' && !parent.props.text && !parent.props.outlined && !parent.props.plain
        },
        // Info Text Button
        {
          'text-info-500 dark:text-info-400':
            parent.props.text && parent.props.severity === 'info' && !parent.props.plain
        },
        // Info Outlined Button
        {
          'text-info-500 border border-info-500 hover:bg-info-300/20 ':
            parent.props.outlined && parent.props.severity === 'info' && !parent.props.plain
        },

        // Warning Button
        {
          'text-white dark:text-secondary-900':
            parent.props.severity === 'warning' && !parent.props.text && !parent.props.outlined && !parent.props.plain,
          'bg-warning-500 dark:bg-warning-400':
            parent.props.severity === 'warning' && !parent.props.text && !parent.props.outlined && !parent.props.plain,
          'border border-warning-500 dark:border-warning-400':
            parent.props.severity === 'warning' && !parent.props.text && !parent.props.outlined && !parent.props.plain
        },
        // Warning Text Button
        {
          'text-warning-500 dark:text-warning-400':
            parent.props.text && parent.props.severity === 'warning' && !parent.props.plain
        },
        // Warning Outlined Button
        {
          'text-warning-500 border border-warning-500 hover:bg-warning-300/20':
            parent.props.outlined && parent.props.severity === 'warning' && !parent.props.plain
        },

        // Help Button
        {
          'text-white dark:text-secondary-900':
            parent.props.severity === 'help' && !parent.props.text && !parent.props.outlined && !parent.props.plain,
          'bg-purple-500 dark:bg-purple-400':
            parent.props.severity === 'help' && !parent.props.text && !parent.props.outlined && !parent.props.plain,
          'border border-purple-500 dark:border-purple-400':
            parent.props.severity === 'help' && !parent.props.text && !parent.props.outlined && !parent.props.plain
        },
        // Help Text Button
        {
          'text-purple-500 dark:text-purple-400':
            parent.props.text && parent.props.severity === 'help' && !parent.props.plain
        },
        // Help Outlined Button
        {
          'text-purple-500 border border-purple-500 hover:bg-purple-300/20':
            parent.props.outlined && parent.props.severity === 'help' && !parent.props.plain
        },

        // Danger Button
        {
          'text-white dark:text-secondary-900':
            parent.props.severity === 'danger' && !parent.props.text && !parent.props.outlined && !parent.props.plain,
          'bg-danger-500 dark:bg-danger-400':
            parent.props.severity === 'danger' && !parent.props.text && !parent.props.outlined && !parent.props.plain,
          'border border-danger-500 dark:border-danger-400':
            parent.props.severity === 'danger' && !parent.props.text && !parent.props.outlined && !parent.props.plain
        },
        // Danger Text Button
        {
          'text-danger-500 dark:text-danger-400':
            parent.props.text && parent.props.severity === 'danger' && !parent.props.plain
        },
        // Danger Outlined Button
        {
          'text-danger-500 border border-danger-500 hover:bg-danger-300/20':
            parent.props.outlined && parent.props.severity === 'danger' && !parent.props.plain
        },

        // --- Severity Button States ---
        'focus:outline-none focus:outline-offset-0 focus:ring',

        // Link
        { 'focus:ring-primary-400/50 dark:focus:ring-primary-300/50': parent.props.link },

        // Plain
        {
          'hover:bg-gray-600 hover:border-gray-600': parent.props.plain && !parent.props.outlined && !parent.props.text
        },
        // Text & Outlined Button
        { 'hover:bg-secondary-300/20': parent.props.plain && (parent.props.text || parent.props.outlined) },

        // Primary
        {
          'hover:bg-primary-600 dark:hover:bg-primary-300 hover:border-primary-600 dark:hover:border-primary-300':
            !parent.props.link &&
            parent.props.severity === null &&
            !parent.props.text &&
            !parent.props.outlined &&
            !parent.props.plain
        },
        {
          'focus:ring-primary-400/50 dark:focus:ring-primary-300/50':
            !parent.props.link &&
            parent.props.severity === null &&
            !parent.props.text &&
            !parent.props.outlined &&
            !parent.props.plain
        },
        // Text & Outlined Button
        {
          'hover:bg-primary-300/20':
            (parent.props.text || parent.props.outlined) && parent.props.severity === null && !parent.props.plain
        },

        // Secondary
        {
          'hover:bg-secondary-600 dark:hover:bg-secondary-300 hover:border-secondary-600 dark:hover:border-secondary-300':
            parent.props.severity === 'secondary' && !parent.props.text && !parent.props.outlined && !parent.props.plain
        },
        { 'focus:ring-secondary-400/50 dark:focus:ring-secondary-300/50': parent.props.severity === 'secondary' },
        // Text & Outlined Button
        {
          'hover:bg-secondary-300/20':
            (parent.props.text || parent.props.outlined) && parent.props.severity === 'secondary' && !parent.props.plain
        },

        // Success
        {
          'hover:bg-green-600 dark:hover:bg-green-300 hover:border-green-600 dark:hover:border-green-300':
            parent.props.severity === 'success' && !parent.props.text && !parent.props.outlined && !parent.props.plain
        },
        { 'focus:ring-green-400/50 dark:focus:ring-green-300/50': parent.props.severity === 'success' },
        // Text & Outlined Button
        {
          'hover:bg-green-300/20':
            (parent.props.text || parent.props.outlined) && parent.props.severity === 'success' && !parent.props.plain
        },

        // Info
        {
          'hover:bg-info-600 dark:hover:bg-info-300 hover:border-info-600 dark:hover:border-info-300':
            parent.props.severity === 'info' && !parent.props.text && !parent.props.outlined && !parent.props.plain
        },
        { 'focus:ring-info-400/50 dark:focus:ring-info-300/50': parent.props.severity === 'info' },
        // Text & Outlined Button
        {
          'hover:bg-info-300/20':
            (parent.props.text || parent.props.outlined) && parent.props.severity === 'info' && !parent.props.plain
        },

        // Warning
        {
          'hover:bg-warning-600 dark:hover:bg-warning-300 hover:border-warning-600 dark:hover:border-warning-300':
            parent.props.severity === 'warning' && !parent.props.text && !parent.props.outlined && !parent.props.plain
        },
        { 'focus:ring-warning-400/50 dark:focus:ring-warning-300/50': parent.props.severity === 'warning' },
        // Text & Outlined Button
        {
          'hover:bg-warning-300/20':
            (parent.props.text || parent.props.outlined) && parent.props.severity === 'warning' && !parent.props.plain
        },

        // Help
        {
          'hover:bg-purple-600 dark:hover:bg-purple-300 hover:border-purple-600 dark:hover:border-purple-300':
            parent.props.severity === 'help' && !parent.props.text && !parent.props.outlined && !parent.props.plain
        },
        { 'focus:ring-purple-400/50 dark:focus:ring-purple-300/50': parent.props.severity === 'help' },
        // Text & Outlined Button
        {
          'hover:bg-purple-300/20':
            (parent.props.text || parent.props.outlined) && parent.props.severity === 'help' && !parent.props.plain
        },

        // Warning
        {
          'hover:bg-danger-600 dark:hover:bg-danger-300 hover:border-danger-600 dark:hover:border-danger-300':
            parent.props.severity === 'danger' && !parent.props.text && !parent.props.outlined && !parent.props.plain
        },
        { 'focus:ring-danger-400/50 dark:focus:ring-danger-300/50': parent.props.severity === 'danger' },
        // Text & Outlined Button
        {
          'hover:bg-danger-300/20':
            (parent.props.text || parent.props.outlined) && parent.props.severity === 'danger' && !parent.props.plain
        },

        { 'opacity-60 pointer-events-none cursor-default': context.disabled },

        // Transitions
        'transition duration-200 ease-in-out',

        // Misc
        'cursor-pointer overflow-hidden select-none',
        // Disabled
        { 'opacity-60 pointer-events-none cursor-default': context?.disabled },
      ]
    }),
    icon: {
      class: [
        // Margins
        'mr-2'
      ]
    }
  },
  menubutton: {
    root: ({ parent, context }) => ({
      class: [
        'relative',
        // Alignments
        'items-center inline-flex text-center align-bottom justify-center',

        // Sizes & Spacing
        {
          'px-4 py-3 leading-none': parent.props.size === null && parent.props.label !== null,
          'text-xs py-2 px-3': parent.props.size === 'small',
          'text-xl py-3 px-4': parent.props.size === 'large'
        },
        {
          'h-12 w-12 p-0': parent.props.label == null
        },

        // Shape
        'rounded-l-none',
        { 'rounded-l-full': parent.props.rounded },
        { 'rounded-md': !parent.props.rounded, 'rounded-full': parent.props.rounded },

        // Link Button
        { 'text-primary-600 bg-transparent border-transparent': parent.props.link },

        // Plain Button
        {
          'text-white bg-gray-500 border border-gray-500':
            parent.props.plain && !parent.props.outlined && !parent.props.text
        },
        // Plain Text Button
        { 'text-secondary-500': parent.props.plain && parent.props.text },
        // Plain Outlined Button
        { 'text-secondary-500 border border-gray-500': parent.props.plain && parent.props.outlined },

        // Text Button
        { 'bg-transparent border-transparent': parent.props.text && !parent.props.plain },

        // Outlined Button
        { 'bg-transparent border': parent.props.outlined && !parent.props.plain },

        // --- Severity Buttons ---

        // Primary Button
        {
          'text-white dark:text-secondary-900':
            !parent.props.link &&
            parent.props.severity === null &&
            !parent.props.text &&
            !parent.props.outlined &&
            !parent.props.plain,
          'bg-primary-500 dark:bg-primary-400':
            !parent.props.link &&
            parent.props.severity === null &&
            !parent.props.text &&
            !parent.props.outlined &&
            !parent.props.plain,
          'border border-primary-500 dark:border-primary-400':
            !parent.props.link &&
            parent.props.severity === null &&
            !parent.props.text &&
            !parent.props.outlined &&
            !parent.props.plain
        },
        // Primary Text Button
        {
          'text-primary-500 dark:text-primary-400':
            parent.props.text && parent.props.severity === null && !parent.props.plain
        },
        // Primary Outlined Button
        {
          'text-primary-500 border border-primary-500 hover:bg-primary-300/20':
            parent.props.outlined && parent.props.severity === null && !parent.props.plain
        },

        // Secondary Button
        {
          'text-white dark:text-secondary-900':
            parent.props.severity === 'secondary' &&
            !parent.props.text &&
            !parent.props.outlined &&
            !parent.props.plain,
          'bg-secondary-500 dark:bg-secondary-400':
            parent.props.severity === 'secondary' &&
            !parent.props.text &&
            !parent.props.outlined &&
            !parent.props.plain,
          'border border-secondary-500 dark:border-secondary-400':
            parent.props.severity === 'secondary' && !parent.props.text && !parent.props.outlined && !parent.props.plain
        },
        // Secondary Text Button
        {
          'text-secondary-500 dark:text-secondary-400':
            parent.props.text && parent.props.severity === 'secondary' && !parent.props.plain
        },
        // Secondary Outlined Button
        {
          'text-secondary-500 border border-secondary-500 hover:bg-secondary-300/20':
            parent.props.outlined && parent.props.severity === 'secondary' && !parent.props.plain
        },

        // Success Button
        {
          'text-white dark:text-secondary-900':
            parent.props.severity === 'success' && !parent.props.text && !parent.props.outlined && !parent.props.plain,
          'bg-green-500 dark:bg-green-400':
            parent.props.severity === 'success' && !parent.props.text && !parent.props.outlined && !parent.props.plain,
          'border border-green-500 dark:border-green-400':
            parent.props.severity === 'success' && !parent.props.text && !parent.props.outlined && !parent.props.plain
        },
        // Success Text Button
        {
          'text-secondary-500 dark:text-secondary-400':
            parent.props.text && parent.props.severity === 'secondary' && !parent.props.plain
        },
        // Success Outlined Button
        {
          'text-green-500 border border-green-500 hover:bg-green-300/20':
            parent.props.outlined && parent.props.severity === 'success' && !parent.props.plain
        },

        // Info Button
        {
          'text-white dark:text-secondary-900':
            parent.props.severity === 'info' && !parent.props.text && !parent.props.outlined && !parent.props.plain,
          'bg-info-500 dark:bg-info-400':
            parent.props.severity === 'info' && !parent.props.text && !parent.props.outlined && !parent.props.plain,
          'border border-info-500 dark:border-info-400':
            parent.props.severity === 'info' && !parent.props.text && !parent.props.outlined && !parent.props.plain
        },
        // Info Text Button
        {
          'text-info-500 dark:text-info-400':
            parent.props.text && parent.props.severity === 'info' && !parent.props.plain
        },
        // Info Outlined Button
        {
          'text-info-500 border border-info-500 hover:bg-info-300/20 ':
            parent.props.outlined && parent.props.severity === 'info' && !parent.props.plain
        },

        // Warning Button
        {
          'text-white dark:text-secondary-900':
            parent.props.severity === 'warning' && !parent.props.text && !parent.props.outlined && !parent.props.plain,
          'bg-warning-500 dark:bg-warning-400':
            parent.props.severity === 'warning' && !parent.props.text && !parent.props.outlined && !parent.props.plain,
          'border border-warning-500 dark:border-warning-400':
            parent.props.severity === 'warning' && !parent.props.text && !parent.props.outlined && !parent.props.plain
        },
        // Warning Text Button
        {
          'text-warning-500 dark:text-warning-400':
            parent.props.text && parent.props.severity === 'warning' && !parent.props.plain
        },
        // Warning Outlined Button
        {
          'text-warning-500 border border-warning-500 hover:bg-warning-300/20':
            parent.props.outlined && parent.props.severity === 'warning' && !parent.props.plain
        },

        // Help Button
        {
          'text-white dark:text-secondary-900':
            parent.props.severity === 'help' && !parent.props.text && !parent.props.outlined && !parent.props.plain,
          'bg-purple-500 dark:bg-purple-400':
            parent.props.severity === 'help' && !parent.props.text && !parent.props.outlined && !parent.props.plain,
          'border border-purple-500 dark:border-purple-400':
            parent.props.severity === 'help' && !parent.props.text && !parent.props.outlined && !parent.props.plain
        },
        // Help Text Button
        {
          'text-purple-500 dark:text-purple-400':
            parent.props.text && parent.props.severity === 'help' && !parent.props.plain
        },
        // Help Outlined Button
        {
          'text-purple-500 border border-purple-500 hover:bg-purple-300/20':
            parent.props.outlined && parent.props.severity === 'help' && !parent.props.plain
        },

        // Danger Button
        {
          'text-white dark:text-secondary-900':
            parent.props.severity === 'danger' && !parent.props.text && !parent.props.outlined && !parent.props.plain,
          'bg-danger-500 dark:bg-danger-400':
            parent.props.severity === 'danger' && !parent.props.text && !parent.props.outlined && !parent.props.plain,
          'border border-danger-500 dark:border-danger-400':
            parent.props.severity === 'danger' && !parent.props.text && !parent.props.outlined && !parent.props.plain
        },
        // Danger Text Button
        {
          'text-danger-500 dark:text-danger-400':
            parent.props.text && parent.props.severity === 'danger' && !parent.props.plain
        },
        // Danger Outlined Button
        {
          'text-danger-500 border border-danger-500 hover:bg-danger-300/20':
            parent.props.outlined && parent.props.severity === 'danger' && !parent.props.plain
        },

        // --- Severity Button States ---
        'focus:outline-none focus:outline-offset-0 focus:ring',

        // Link
        { 'focus:ring-primary-400/50 dark:focus:ring-primary-300/50': parent.props.link },

        // Plain
        {
          'hover:bg-gray-600 hover:border-gray-600': parent.props.plain && !parent.props.outlined && !parent.props.text
        },
        // Text & Outlined Button
        { 'hover:bg-secondary-300/20': parent.props.plain && (parent.props.text || parent.props.outlined) },

        // Primary
        {
          'hover:bg-primary-600 dark:hover:bg-primary-300 hover:border-primary-600 dark:hover:border-primary-300':
            !parent.props.link &&
            parent.props.severity === null &&
            !parent.props.text &&
            !parent.props.outlined &&
            !parent.props.plain
        },
        {
          'focus:ring-primary-400/50 dark:focus:ring-primary-300/50':
            !parent.props.link &&
            parent.props.severity === null &&
            !parent.props.text &&
            !parent.props.outlined &&
            !parent.props.plain
        },
        // Text & Outlined Button
        {
          'hover:bg-primary-300/20':
            (parent.props.text || parent.props.outlined) && parent.props.severity === null && !parent.props.plain
        },

        // Secondary
        {
          'hover:bg-secondary-600 dark:hover:bg-secondary-300 hover:border-secondary-600 dark:hover:border-secondary-300':
            parent.props.severity === 'secondary' && !parent.props.text && !parent.props.outlined && !parent.props.plain
        },
        { 'focus:ring-secondary-400/50 dark:focus:ring-secondary-300/50': parent.props.severity === 'secondary' },
        // Text & Outlined Button
        {
          'hover:bg-secondary-300/20':
            (parent.props.text || parent.props.outlined) && parent.props.severity === 'secondary' && !parent.props.plain
        },

        // Success
        {
          'hover:bg-green-600 dark:hover:bg-green-300 hover:border-green-600 dark:hover:border-green-300':
            parent.props.severity === 'success' && !parent.props.text && !parent.props.outlined && !parent.props.plain
        },
        { 'focus:ring-green-400/50 dark:focus:ring-green-300/50': parent.props.severity === 'success' },
        // Text & Outlined Button
        {
          'hover:bg-green-300/20':
            (parent.props.text || parent.props.outlined) && parent.props.severity === 'success' && !parent.props.plain
        },

        // Info
        {
          'hover:bg-info-600 dark:hover:bg-info-300 hover:border-info-600 dark:hover:border-info-300':
            parent.props.severity === 'info' && !parent.props.text && !parent.props.outlined && !parent.props.plain
        },
        { 'focus:ring-info-400/50 dark:focus:ring-info-300/50': parent.props.severity === 'info' },
        // Text & Outlined Button
        {
          'hover:bg-info-300/20':
            (parent.props.text || parent.props.outlined) && parent.props.severity === 'info' && !parent.props.plain
        },

        // Warning
        {
          'hover:bg-warning-600 dark:hover:bg-warning-300 hover:border-warning-600 dark:hover:border-warning-300':
            parent.props.severity === 'warning' && !parent.props.text && !parent.props.outlined && !parent.props.plain
        },
        { 'focus:ring-warning-400/50 dark:focus:ring-warning-300/50': parent.props.severity === 'warning' },
        // Text & Outlined Button
        {
          'hover:bg-warning-300/20':
            (parent.props.text || parent.props.outlined) && parent.props.severity === 'warning' && !parent.props.plain
        },

        // Help
        {
          'hover:bg-purple-600 dark:hover:bg-purple-300 hover:border-purple-600 dark:hover:border-purple-300':
            parent.props.severity === 'help' && !parent.props.text && !parent.props.outlined && !parent.props.plain
        },
        { 'focus:ring-purple-400/50 dark:focus:ring-purple-300/50': parent.props.severity === 'help' },
        // Text & Outlined Button
        {
          'hover:bg-purple-300/20':
            (parent.props.text || parent.props.outlined) && parent.props.severity === 'help' && !parent.props.plain
        },

        // Warning
        {
          'hover:bg-danger-600 dark:hover:bg-danger-300 hover:border-danger-600 dark:hover:border-danger-300':
            parent.props.severity === 'danger' && !parent.props.text && !parent.props.outlined && !parent.props.plain
        },
        { 'focus:ring-danger-400/50 dark:focus:ring-danger-300/50': parent.props.severity === 'danger' },
        // Text & Outlined Button
        {
          'hover:bg-danger-300/20':
            (parent.props.text || parent.props.outlined) && parent.props.severity === 'danger' && !parent.props.plain
        },

        { 'opacity-60 pointer-events-none cursor-default': context.disabled },

        // Transitions
        'transition duration-200 ease-in-out',

        // Misc
        'cursor-pointer overflow-hidden select-none',
        // Disabled
        { 'opacity-60 pointer-events-none cursor-default': context?.disabled },
      ]
    }),
    label: {
      class: ['hidden']
    }
  }
};
